<div class="PageContent">

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteProductQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteProductQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.StockLoading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteProductQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.StockLoading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteProductQuestion = false;DeleteIndustryProductStockOffer();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <!-- Export stock popup (commented out - now exports directly)
  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowExportStockQuestion">
    ...
  </div>
  -->

  <div class="NewProductContainer ModernPanel animated fadeInDown" *ngIf="ShowNewStockEntryContainer == true;">
    <div class="NewProductContainerTitleBar">
      <p *ngIf="this.NewProduct.ID == 0;">{{'AddStockEntry' | translate}}</p>
      <p *ngIf="this.NewProduct.ID > 0;">{{'UpdateStockEntry' | translate}}: {{this.NewProduct.Brand.Name}} {{this.NewProduct.Name}}</p>
      <i class="material-icons" (click)="ShowNewStockEntryContainer = false;">close</i>
    </div>
    <div class="NewProductContainerBody">
      <div class="TwoThirdsColumn">

        <div class="ModernFormSectionTitle">
          <i class="material-icons">radio_button_checked</i>
          {{'GeneralInformation' | translate}}
        </div>

        <div class="ModernSearchContainer">
          <div class="ModernSearchBar">
            <i class="material-icons search-icon">search</i>
            <input type="text" class="ModernSearchInput" placeholder="{{'SearchProducts' | translate}}" autocomplete="off" (click)="InitializeSearchProduct();" [(ngModel)]="this.SearchTerm" (ngModelChange)="this.productSearchTermUpdate.next($event)">
            <i class="material-icons clear-icon" *ngIf="this.SearchTerm?.length > 0;" (click)="ClearSearchIndustryProducts();">close</i>
          </div>
          <div class="ModernSearchResults" *ngIf="this.SearchedProducts?.length > 0">
            <div class="ModernSearchResultItem" *ngFor="let p of this.SearchedProducts" (click)="GetIndustryProductByID(p.ProductID, true);">
              <span class="ModernSearchResultTitle">
                {{p.FKBrandName}} {{p.ProductName}}
              </span>
              <span class="ModernSearchResultSub">
                {{p.ProductPartNumber}}
              </span>
            </div>
          </div>
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'Name' | translate }}*</label>
          <input disabled class="ModernFormInput" placeholder="{{ 'Name' | translate }}*" autocomplete="off" [(ngModel)]="this.NewProduct.Name">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'PartNumber' | translate }}</label>
          <input disabled class="ModernFormInput" placeholder="{{ 'PartNumber' | translate }}" autocomplete="off" [(ngModel)]="this.NewProduct.PartNumber">
        </div>

        <div class="ModernAutocompleteContainer">
          <label class="ModernFormLabel">{{'SelectBrand' | translate}}*</label>
          <div class="ModernAutocompleteBar">
            <i class="material-icons search-icon" *ngIf="(this.NewProduct.Brand?.Name?.length > 0) != true;">search</i>
            <input disabled class="ModernAutocompleteInput"
                   type="text"
                   placeholder="{{'SelectBrand' | translate}}"
                   [matAutocomplete]="auto1"
                   [(ngModel)]="this.NewProduct.Brand.Name"
                   (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                   (click)="InitializeBrands();">
          </div>
          <mat-autocomplete #auto1="matAutocomplete">
            <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.NewProduct.Brand = brand;">
              {{brand.Name}}
            </mat-option>
          </mat-autocomplete>
        </div>

      </div>

      <div class="OneThirdColumn">
      </div>

      <div class="ModernFormDivider"></div>

      <div class="TwoThirdsColumn">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">account_tree</i>
          {{'StockInfo' | translate}}
        </div>

        <div class="ModernAutocompleteContainer" matTooltip="{{ 'ConfigurationWarehouseDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>
          <label class="ModernFormLabel">{{'SelectWarehouse' | translate}}</label>
          <div class="ModernAutocompleteBar">
            <i class="material-icons search-icon" *ngIf="(this.Configuration.Warehouse?.Name?.length > 0) != true;">search</i>
            <input id="warehouseselectid" class="ModernAutocompleteInput"
                   type="text"
                   placeholder="{{'SelectWarehouse' | translate}}"
                   [matAutocomplete]="auto4"
                   [(ngModel)]="this.ConfigurationWarehouseName"
                   (ngModelChange)="this.warehouseSearchTermUpdate.next($event)"
                   (click)="InitializeWarehouses();">
          </div>
          <mat-autocomplete #auto4="matAutocomplete">
            <mat-option *ngFor="let warehouse of this.Warehouses" [value]="warehouse" (click)="this.Configuration.Warehouse = warehouse; this.ConfigurationWarehouseName = warehouse.Name; GetImportConfigurationByWarehouse(warehouse.ID);">
              {{warehouse.Name}}
            </mat-option>
          </mat-autocomplete>
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'LeadTimeType' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownBar" [class.open]="ShowLeadTimeTypeDropdown" [class.disabled]="this.Configuration?.Warehouse?.StockLeadTime?.Type != null" (click)="ShowLeadTimeTypeDropdown = !ShowLeadTimeTypeDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.Configuration.Warehouse.StockLeadTime.Type">
                {{this.Configuration.Warehouse.StockLeadTime.Type?.Name || ('LeadTimeType' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="ShowLeadTimeTypeDropdown">
              <div class="ModernDropdownOption" *ngFor="let t of this.LeadTimeTypes" [class.selected]="this.parent.compareFn(this.Configuration.Warehouse.StockLeadTime.Type, t)" (click)="this.Configuration.Warehouse.StockLeadTime.Type = t; ShowLeadTimeTypeDropdown = false;">
                {{t.Name}}
                <i class="material-icons check-icon" *ngIf="this.parent.compareFn(this.Configuration.Warehouse.StockLeadTime.Type, t)">check</i>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernFormGroup" *ngIf="this.Configuration.Warehouse.StockLeadTime != null">
          <label class="ModernFormLabel">{{'Units' | translate}}</label>
          <input class="ModernFormInput" [disabled]="this.Configuration?.Warehouse?.StockLeadTime?.Units != null" placeholder="{{'Units' | translate}}" autocomplete="off" [(ngModel)]="this.Configuration.Warehouse.StockLeadTime.Units">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'ProductConditionStatus' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownBar" [class.open]="ShowConditionStatusDropdown" (click)="ShowConditionStatusDropdown = !ShowConditionStatusDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.ListPriceOffer.ConditionStatus">
                {{this.ListPriceOffer.ConditionStatus?.Name || ('ProductConditionStatus' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="ShowConditionStatusDropdown">
              <div class="ModernDropdownOption" *ngFor="let s of this.ProductConditionStatuses" [class.selected]="this.parent.compareFn(this.ListPriceOffer.ConditionStatus, s)" (click)="this.ListPriceOffer.ConditionStatus = s; ShowConditionStatusDropdown = false;">
                {{s.Name}}
                <i class="material-icons check-icon" *ngIf="this.parent.compareFn(this.ListPriceOffer.ConditionStatus, s)">check</i>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'ProductBoxStatus' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownBar" [class.open]="ShowBoxStatusDropdown" (click)="ShowBoxStatusDropdown = !ShowBoxStatusDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.ListPriceOffer.BoxStatus">
                {{this.ListPriceOffer.BoxStatus?.Name || ('ProductBoxStatus' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="ShowBoxStatusDropdown">
              <div class="ModernDropdownOption" *ngFor="let s of this.ProductBoxStatuses" [class.selected]="this.parent.compareFn(this.ListPriceOffer.BoxStatus, s)" (click)="this.ListPriceOffer.BoxStatus = s; ShowBoxStatusDropdown = false;">
                {{s.Name}}
                <i class="material-icons check-icon" *ngIf="this.parent.compareFn(this.ListPriceOffer.BoxStatus, s)">check</i>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="OneThirdColumn">

        <div class="ModernFormSectionTitle">
          <i class="material-icons">account_tree</i>
          {{'StockInfo' | translate}}
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'ListPrice' | translate}}</label>
          <input class="ModernFormInput" placeholder="{{'ListPrice' | translate}}" autocomplete="off" [(ngModel)]="this.ListPriceOffer.ListPrice">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'DiscountedPrice' | translate}}</label>
          <input class="ModernFormInput" placeholder="{{'DiscountedPrice' | translate}}" autocomplete="off" [(ngModel)]="this.ListPriceOffer.DiscountedPrice">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'StockQuantity' | translate}}</label>
          <input class="ModernFormInput" placeholder="{{'StockQuantity' | translate}}" autocomplete="off" [(ngModel)]="this.ListPriceOffer.StockQuantity">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'Currency' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownBar" [class.open]="ShowCurrencyDropdown" (click)="ShowCurrencyDropdown = !ShowCurrencyDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.ListPriceOffer.Currency">
                {{this.ListPriceOffer.Currency?.Name || ('Currency' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="ShowCurrencyDropdown">
              <div class="ModernDropdownOption" *ngFor="let c of this.Currencies" [class.selected]="this.parent.compareFn(c, this.ListPriceOffer.Currency)" (click)="this.ListPriceOffer.Currency = c; ShowCurrencyDropdown = false;">
                {{c.Name}}
                <i class="material-icons check-icon" *ngIf="this.parent.compareFn(c, this.ListPriceOffer.Currency)">check</i>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'MOQ' | translate}}</label>
          <input class="ModernFormInput" placeholder="{{'MOQ' | translate}}" autocomplete="off" [(ngModel)]="this.ListPriceOffer.MOQ">
        </div>

      </div>
    </div>
    <div class="NewProductContainerCommands">
      <div class="GridCommandButton GridCommandButtonGreen" style="float: left; margin-left: 15px; margin-top: 7px;" *ngIf="this.ListPriceOffer.ID == 0;" (click)="AddUpdateListPriceOffer(this.ListPriceOffer);">
        <i class="material-icons">add</i>
        <span>{{'AddStockEntry' | translate}}</span>
      </div>

      <div class="GridCommandButton GridCommandButtonBlue" style="float: left; margin-left: 15px; margin-top: 7px;" *ngIf="this.ListPriceOffer.ID > 0;" (click)="AddUpdateListPriceOffer(this.ListPriceOffer);">
        <i class="material-icons">edit</i>
        <span>{{'UpdateStockEntry' | translate}}</span>
      </div>
    </div>
  </div>

  <div class="overlayTransparent animated fadeIn" *ngIf="ShowFilter == true;" (click)="CloseOverlay();"></div>
  <div class="overlay animated fadeIn" *ngIf="ShowNewStockEntryContainer || ShowDeleteProductQuestion" (click)="CloseDashMenu();" style="z-index: 202;"></div>

  <div class="PageContentTitle">
      <div class="PageContentTitleIntro">
          <i class="material-icons">account_tree</i>
          <p class="PageContentTitleParagraph">{{'StockProducts' | translate}}</p>
      </div>

      <div class="ModernStockSearchContainer">
        <div class="ModernStockSearchBar">
          <i class="material-icons search-icon">search</i>
          <input type="text" class="ModernStockSearchInput" placeholder="{{'SearchStockProducts' | translate}}" autocomplete="off" [(ngModel)]="this.Filter.SearchTerm" (ngModelChange)="this.searchTermUpdate.next($event)">
          <i class="material-icons clear-icon" *ngIf="this.Filter.SearchTerm?.length > 0;" (click)="this.Filter.SearchTerm = ''; GetFilteredBulkStockOffers();">close</i>
        </div>
      </div>

      <div class="PageContentTitleCommands" style="display: flex; align-items: center; gap: 6px; padding-top: 14px;">
          <!-- Filter button (commented out for now)
          <div class="GridCommandButton" (click)="ShowFilter = !ShowFilter;" style="position: relative;">
              <i class="material-icons">filter_alt</i>
              <span>{{'Filter' | translate}}</span>
              <span class="ButtonNotification" *ngIf="activeFilters.length > 0;">{{activeFilters.length}}</span>
          </div>
          -->

          <div class="GridCommandButton GridCommandButtonGreen" (click)="InitializeNewStockEntry();">
              <i class="material-icons">add</i>
              <span>{{'NewStock' | translate}}</span>
          </div>

          <div class="GridCommandButton GridCommandButtonBlue" [ngClass]="{'GridCommandButtonDisabled': ExportLoading}" (click)="ExportBulkStockValues();">
            <mat-spinner [diameter]="18" *ngIf="ExportLoading" style="display:inline-block;vertical-align:middle;"></mat-spinner>
            <i class="material-icons" *ngIf="!ExportLoading">downloading</i>
            <span *ngIf="!ExportLoading">{{'ExportStocks' | translate}}</span>
          </div>
      </div>
  </div>

    <div class="GridModeTabsWrapper">
      <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': SelectedStockTab === 'Stock-Products'}" (click)="OnTabChange('Stock-Products')">
        <i class="material-icons">inventory</i>
        <span>{{'Stock-Products' | translate}}</span>
      </div>
      <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': SelectedStockTab === 'Added-Offers'}" (click)="OnTabChange('Added-Offers')">
        <i class="material-icons">add_circle</i>
        <span>{{'Added-Offers' | translate}}</span>
      </div>
    </div>

    <div class="PageContentBody animated fadeIn" *ngIf="SelectedStockTab === 'Stock-Products'">
      <div class="PageContentBodyTopCommands">

        <mat-form-field class="ButtonFilterDropDown" appearance="outline">
          <mat-label>{{'SelectBrand' | translate}}*</mat-label>
          <input class="BrandSelect"
                 type="text"
                 placeholder="{{'SelectBrand' | translate}}"
                 matInput
                 [matAutocomplete]="auto2"
                 [(ngModel)]="this.FilterBrandName"
                 (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                 (click)="InitializeBrands();">
          <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Filter.Brand?.Name?.length > 0;" (click)="ClearSearchBrand();">close</i>
          <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Filter.Brand?.Name?.length > 0) != true;">search</i>
          <mat-autocomplete #auto2="matAutocomplete">
            <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Filter.Brand = brand; this.FilterBrandName = this.Filter.Brand.Name; GetFilteredBulkStockOffers();">
              {{brand.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <!-- Partner filter (commented out for now)
        <mat-form-field class="ButtonFilterDropDown" appearance="outline">
          <mat-label>{{'SelectPartner' | translate}}</mat-label>
          <input class="BrandSelect"
                 type="text"
                 placeholder="{{'SelectPartner' | translate}}"
                 matInput
                 [matAutocomplete]="autoPartner"
                 [(ngModel)]="this.StockFilterPartnerName"
                 (ngModelChange)="this.stockPartnerSearchTermUpdate.next($event)"
                 (click)="InitializeStockFilterPartners();">
          <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Filter.Partner?.Name?.length > 0;" (click)="ClearStockFilterPartner();">close</i>
          <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Filter.Partner?.Name?.length > 0) != true;">search</i>
          <mat-autocomplete #autoPartner="matAutocomplete">
            <mat-option *ngFor="let partner of StockFilterPartners" [value]="partner" (click)="this.Filter.Partner = partner; this.StockFilterPartnerName = partner.Name; GetFilteredBulkStockOffers(1);">
              {{partner.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        -->

        <div class="TopLevelPaginator unSelectable">
          <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetFilteredBulkStockOffers(this.Filter.Pager.PageIndex - 1);">
            <i class="material-icons">chevron_left</i>
          </div>
          <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_left</i>
          </div>

          <mat-form-field appearance="outline" class="TopLevelPaginatorTextBox">
            <mat-label>{{ 'PageSize' | translate }}*</mat-label>
            <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetFilteredBulkStockOffers(1);">
          </mat-form-field>

          <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetFilteredBulkStockOffers(this.Filter.Pager.PageIndex + 1);">
            <i class="material-icons">chevron_right</i>
          </div>
          <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_right</i>
          </div>

          <span class="pageInfoSpan">{{this.FilteredStockOffers?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'StockProducts' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
        </div>

        <div class="GridCommandButton GridCommandButtonBlue" style="float: right; margin-top: 14px; margin-right: 15px;" (click)="GetFilteredBulkStockOffers();">
          <i class="material-icons">check</i>
          <span>{{'ApplyFilter' | translate}}</span>
        </div>
      </div>

      <div class="PageContentBodyElementsContainer">
        <div class="TaskRow TaskHeadderRow">
          <div class="ProductsCol dottedRow" style="width: 3%;text-align:center;">
            #
          </div>
          <div class="ProductsCol" style="width: 25%;">
            {{'Name' | translate}}
          </div>
          <div class="ProductsCol" style="width: 14%;">
            {{'Properties' | translate}}
          </div>
          <div class="ProductsCol" style="width: 9%;">
            {{'Brand' | translate}}
          </div>
          <div class="ProductsCol" style="width: 11%;">
            {{'Warehouse' | translate}}
          </div>
          <div class="ProductsCol" style="width: 8%;text-align:center;">
            {{'LeadTime' | translate}}
          </div>
          <div class="ProductsCol" style="width: 6%;text-align:center;">
            {{'Quantity' | translate}}
          </div>
          <div class="ProductsCol" style="width: 6%;text-align:center;">
            {{'Currency' | translate}}
          </div>
          <div class="ProductsCol" style="width: 18%;text-align:center;">
            {{'Price' | translate}}
          </div>
        </div>

        <div class="ProductsContainer" style="position: relative;">
          <div class="StockLoadingOverlay" *ngIf="this.StockLoading">
            <mat-spinner [diameter]="40"></mat-spinner>
          </div>
          <div class="ProductRow" *ngFor="let p of this.FilteredStockOffers; let i=index;">
            <div style="background: #32aa3a;" class="ProductsColWarnBubble">
            </div>
            <div class="ProductsCol dottedRow" style="width: 3%;text-align:center;">
              {{i + 1}}
            </div>
            <div class="ProductsCol" style="width: 25%;padding-top: 20px;">
              <p class="ProductsColMain" *ngIf="p.Product?.Brand != null;">
                {{p.Product?.Brand?.Name}}
              </p>
              <p class="ProductsColMain">
                <span style="font-size:15px;color: #0082e6;font-weight: 400;">{{p.Product?.Name}}</span>
              </p>
              <p class="ProductsColMain" *ngIf="p.Product?.PartNumber != null;">
                <span class="ProductsColMainSpan">{{'PartNumber' | translate}}: </span>
                {{p.Product?.PartNumber}}
              </p>
            </div>
            <div class="ProductsCol" style="width: 14%;padding-top: 18px;">
              <p class="ProductsColMain" *ngIf="p.Product?.Stats?.HSCode != null;">
                <span class="ProductsColMainSpan">{{'HSCode' | translate}}: </span>
                {{p.Product?.Stats?.HSCode}}
              </p>
              <p class="ProductsColMain" *ngIf="p.Product?.Stats?.COO != null;">
                <span class="ProductsColMainSpan">{{'COO' | translate}}: </span>
                {{p.Product?.Stats?.COO?.ShortName}}
              </p>
              <p class="ProductsColMain" *ngIf="p.Product?.Stats?.EAN != null;">
                <span class="ProductsColMainSpan">{{'EAN' | translate}}: </span>
                {{p.Product?.Stats?.EAN}}
              </p>
              <p class="ProductsColMain" *ngIf="p.Product?.Stats?.Weight != null;">
                <span class="ProductsColMainSpan">{{'Weight' | translate}}: </span>
                {{p.Product?.Stats?.Weight}} {{p.Product?.Stats?.WeightMeasurementType?.Name}}
              </p>
            </div>
            <div class="ProductsCol" style="width: 9%;padding-top: 20px;">
              <p class="ProductsColMain" *ngIf="p.Product?.Brand != null;">
                {{p.Product?.Brand?.Name}}
              </p>
            </div>
            <div class="ProductsCol" style="width: 11%;padding-top: 20px;">
              <p class="ProductsColMain">
                {{p.Product?.ListPriceOffers[0]?.Configuration?.Name}}
              </p>
            </div>
            <div class="ProductsCol" style="width: 8%;text-align:center;">
              {{p.Product?.ListPriceOffers[0]?.LeadTime?.UIOutput}}
            </div>
            <div class="ProductsCol" style="width: 6%;text-align:center;">
              <span class="StockQuantitySpan" [ngClass]="{'alertStock': p.Product?.ListPriceOffers[0]?.StockQuantity < 3, 'lowStock': p.Product?.ListPriceOffers[0]?.StockQuantity >= 3 && p.Product?.ListPriceOffers[0]?.StockQuantity <= 5, 'normalStock': p.Product?.ListPriceOffers[0]?.StockQuantity > 5 && p.Product?.ListPriceOffers[0]?.StockQuantity <= 15, 'bigStock': p.Product?.ListPriceOffers[0]?.StockQuantity > 15 }">{{p.Product?.ListPriceOffers[0]?.StockQuantity}}</span>
            </div>
            <div class="ProductsCol" style="width: 6%;">
              <div class="InlinePriceContainer" *ngIf="p.Product?.ListPriceOffers?.length > 0">
                <select class="InlineCurrencySelect" [ngModel]="p.Product?.ListPriceOffers[0]?.Currency?.ID" (ngModelChange)="OnStockProductCurrencyChange(p, $event)">
                  <option *ngFor="let c of Currencies" [ngValue]="c.ID">{{c.Name}}</option>
                </select>
              </div>
            </div>
            <div class="ProductsCol" style="width: 18%;text-align:center;overflow:visible;">
              <div class="InlinePriceContainer" *ngIf="p.Product?.ListPriceOffers?.length > 0">
                <input type="number" class="InlineSellingPriceInput" [(ngModel)]="p.Product.ListPriceOffers[0].SellPrice.UIUnitPrice" placeholder="0.00" (click)="$event.target.select()">
                <div class="InlineSaveButton" (click)="SaveFilteredStockOfferPrice(p);" matTooltip="{{ 'Save' | translate }}">
                  <i class="material-icons">check</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab 2: Added Offers -->
    <div class="PageContentBody animated fadeIn" *ngIf="SelectedStockTab === 'Added-Offers'">
      <div class="PageContentBodyTopCommands">

            <div class="TopLevelPaginator unSelectable">
              <div class="TopLevelPaginatorButton" *ngIf="this.AddedOffersFilter?.Pager?.PageIndex != 1;" (click)="this.AddedOffersFilter.Pager.PageIndex = this.AddedOffersFilter.Pager.PageIndex - 1; GetAddedOffersFiltered(this.AddedOffersFilter.Pager.PageIndex);">
                <i class="material-icons">chevron_left</i>
              </div>
              <div class="TopLevelPaginatorButton" *ngIf="this.AddedOffersFilter?.Pager?.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                <i class="material-icons">chevron_left</i>
              </div>

              <mat-form-field appearance="outline" class="TopLevelPaginatorTextBox">
                <mat-label>{{ 'PageSize' | translate }}*</mat-label>
                <input matInput autocomplete="off" [(ngModel)]="AddedOffersFilter.Pager.PageSize" (change)="this.AddedOffersFilter.Pager.PageIndex = 1; GetAddedOffersFiltered(1);">
              </mat-form-field>

              <div class="TopLevelPaginatorButton" *ngIf="this.AddedOffersFilter?.Pager?.PageIndex != this.AddedOffersFilter?.Pager?.Pages;" (click)="this.AddedOffersFilter.Pager.PageIndex = this.AddedOffersFilter.Pager.PageIndex + 1; GetAddedOffersFiltered(this.AddedOffersFilter.Pager.PageIndex);">
                <i class="material-icons">chevron_right</i>
              </div>
              <div class="TopLevelPaginatorButton" *ngIf="this.AddedOffersFilter?.Pager?.PageIndex == this.AddedOffersFilter?.Pager?.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                <i class="material-icons">chevron_right</i>
              </div>

              <span class="pageInfoSpan">{{this.AddedOffersProducts?.length}} {{'OfWord' | translate}} {{this.AddedOffersFilter?.Pager?.TotalCount}} {{'Added-Offers' | translate}} ({{'Page' | translate}}: {{this.AddedOffersFilter?.Pager?.PageIndex}} {{'OfWord' | translate}} {{this.AddedOffersFilter?.Pager?.Pages}})</span>
            </div>

            <div class="GridCommandButton GridCommandButtonBlue" style="float: right; margin-top: 14px; margin-right: 15px;" (click)="GetAddedOffersFiltered();">
              <i class="material-icons">check</i>
              <span>{{'ApplyFilter' | translate}}</span>
            </div>
      </div>

      <div class="PageContentBodyElementsContainer">
        <div class="TaskRow TaskHeadderRow">
          <div class="ProductsCol dottedRow" style="width: 4%;text-align:center;">
            #
          </div>
          <div class="ProductsCol dottedRow" style="width: 18%;">
            {{'Name' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 10%;">
            {{'PartNumber' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 10%;">
            {{'Brand' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 8%;">
            {{'ListPrice' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 8%;">
            {{'SellingPrice' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 6%;">
            {{'StockQuantity' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 6%;">
            {{'MOQ' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 8%;">
            {{'Currency' | translate}}
          </div>

        </div>

        <div *ngFor="let p of AddedOffersProducts; let i = index;">
          <div class="TaskRow" *ngIf="p.ListPriceOffers?.length > 0;">
            <div class="ProductsCol dottedRow" style="width: 4%;text-align:center;">
              {{i + 1}}
            </div>
            <div class="ProductsCol dottedRow" style="width: 18%;">
              {{p.Name}}
            </div>
            <div class="ProductsCol dottedRow" style="width: 10%;">
              {{p.PartNumber}}
            </div>
            <div class="ProductsCol dottedRow" style="width: 10%;">
              {{p.Brand?.Name}}
            </div>
            <div class="ProductsCol dottedRow" style="width: 8%;">
              {{p.ListPriceOffers[0]?.ListPrice | number:'1.2-2'}}
            </div>
            <div class="ProductsCol dottedRow" style="width: 8%;">
              <div class="InlinePriceContainer">
                <input class="InlineSellingPriceInput" type="number" [(ngModel)]="p.ListPriceOffers[0].DiscountedPrice" placeholder="0.00" (click)="$event.target.select()">
                <div class="InlineSaveButton" (click)="SaveAddedOfferSellingPrice(p);" title="{{ 'Save' | translate }}">
                  <i class="material-icons">check</i>
                </div>
              </div>
            </div>
            <div class="ProductsCol dottedRow" style="width: 6%;">
              {{p.ListPriceOffers[0]?.StockQuantity}}
            </div>
            <div class="ProductsCol dottedRow" style="width: 6%;">
              {{p.ListPriceOffers[0]?.MOQ}}
            </div>
            <div class="ProductsCol dottedRow" style="width: 8%;">
              <div class="InlinePriceContainer">
                <select class="InlineCurrencySelect" [ngModel]="p.ListPriceOffers[0].Currency?.ID" (ngModelChange)="OnAddedOfferCurrencyChange(p, $event)">
                  <option *ngFor="let c of Currencies" [ngValue]="c.ID">{{c.Name}}</option>
                </select>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

</div>

<!-- ✅ Warehouse Item Positions Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowPositionsPopup" (click)="ClosePositionsPopup();">
  <div class="ModernPopup" style="width: 700px; max-width: 95vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">location_on</i>
        <span>{{ 'WarehousePositions' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ClosePositionsPopup();">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody" style="max-height: 400px; overflow-y: auto;">
      <!-- Positions List -->
      <div class="ModernWarehouseZonesList" *ngIf="WarehouseItemPositions != null && WarehouseItemPositions.length > 0;">
        <div *ngFor="let pos of WarehouseItemPositions" class="ModernWarehouseZone">
          <div class="ModernWarehouseZoneIcon">
            <i class="material-icons">location_on</i>
          </div>
          <div style="flex: 1;">
            <span class="ModernWarehouseZoneName">{{pos.Zone?.Name}}</span>
            <span style="color: #5a7a9a; font-size: 12px; display: block;">
              {{ 'Row' | translate }}: {{pos.Row}}, {{ 'Column' | translate }}: {{pos.Column}}, {{ 'Quantity' | translate }}: {{pos.Quantity}}
            </span>
            <span *ngIf="pos.Description" style="color: #888; font-size: 11px; display: block;">{{pos.Description}}</span>
          </div>
          <div style="display: flex; gap: 4px; margin-left: auto;">
            <button class="ModernActionButton primary" (click)="OpenEditPosition(pos);" matTooltip="{{ 'Edit' | translate }}">
              <i class="material-icons">edit</i>
            </button>
            <button class="ModernActionButton danger" (click)="PrepareDeletePosition(pos);" matTooltip="{{ 'Delete' | translate }}">
              <i class="material-icons">delete</i>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="WarehouseItemPositions == null || WarehouseItemPositions.length == 0" style="text-align: center; padding: 20px; color: #5a7a9a;">
        {{ 'NoPositionsFound' | translate }}
      </div>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" (click)="ClosePositionsPopup();">{{ 'Close' | translate }}</button>
      <button class="ModernButton success" (click)="OpenAddNewPosition();">
        <i class="material-icons">add</i>
        <span>{{ 'AddPosition' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Add/Edit Position Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowAddEditPositionPopup" (click)="CloseAddEditPositionPopup();">
  <div class="ModernPopup" style="width: 500px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" *ngIf="NewPosition.ID == 0;">add</i>
        <i class="material-icons" *ngIf="NewPosition.ID > 0;">edit</i>
        <span *ngIf="NewPosition.ID == 0;">{{ 'AddPosition' | translate }}</span>
        <span *ngIf="NewPosition.ID > 0;">{{ 'EditPosition' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="CloseAddEditPositionPopup();">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'Zone' | translate }}*</label>
        <div class="ZoneSelectorRow">
          <mat-form-field appearance="outline" style="flex: 1;">
            <mat-select [(ngModel)]="NewPosition.Zone" [compareWith]="this.parent.compareFn">
              <mat-option *ngFor="let zone of WHZones" [value]="zone">
                {{zone.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button class="ModernActionButton primary" (click)="OpenAddNewZonePopup();" matTooltip="{{ 'Configuration.AddNewZone' | translate }}">
            <i class="material-icons">add</i>
          </button>
        </div>
      </div>
      <div style="display: flex; gap: 16px;">
        <div class="ModernFormGroup" style="flex: 1;">
          <label class="ModernFormLabel">{{ 'Row' | translate }}*</label>
          <input type="number" class="ModernFormInput" placeholder="{{ 'Row' | translate }}" [(ngModel)]="NewPosition.Row" min="1">
        </div>
        <div class="ModernFormGroup" style="flex: 1;">
          <label class="ModernFormLabel">{{ 'Column' | translate }}*</label>
          <input type="number" class="ModernFormInput" placeholder="{{ 'Column' | translate }}" [(ngModel)]="NewPosition.Column" min="1">
        </div>
      </div>
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'Quantity' | translate }}*</label>
        <input type="number" class="ModernFormInput" placeholder="{{ 'Quantity' | translate }}" [(ngModel)]="NewPosition.Quantity" min="0">
      </div>
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'Description' | translate }}</label>
        <textarea class="ModernFormTextarea" placeholder="{{ 'Description' | translate }}" [(ngModel)]="NewPosition.Description" rows="3"></textarea>
      </div>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" (click)="CloseAddEditPositionPopup();">{{ 'Cancel' | translate }}</button>
      <button class="ModernButton primary" [disabled]="this.StockLoading" (click)="AddUpdateWarehouseItemPosition(NewPosition);">
        <i class="material-icons spinner" *ngIf="this.StockLoading">refresh</i>
        <i class="material-icons" *ngIf="!this.StockLoading && NewPosition.ID == 0;">add</i>
        <i class="material-icons" *ngIf="!this.StockLoading && NewPosition.ID > 0;">save_alt</i>
        <span *ngIf="NewPosition.ID == 0;">{{ 'AddPosition' | translate }}</span>
        <span *ngIf="NewPosition.ID > 0;">{{ 'SavePosition' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Delete Position Confirmation -->
<div class="ModernPopupOverlay" *ngIf="ShowDeletePositionQuestion" (click)="ShowDeletePositionQuestion = false;">
  <div class="ModernPopup" style="width: 420px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #f44336;">warning</i>
        <span>{{ 'Configuration.DeleteQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowDeletePositionQuestion = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p style="margin: 0; font-size: 13px; color: #5a7a9a;">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" (click)="ShowDeletePositionQuestion = false;">{{ 'Cancel' | translate }}</button>
      <button class="ModernButton danger" [disabled]="this.StockLoading" (click)="DeleteWarehouseItemPosition();">
        <i class="material-icons spinner" *ngIf="this.StockLoading">refresh</i>
        <i class="material-icons" *ngIf="!this.StockLoading">delete</i>
        <span>{{ 'Delete' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Add New Zone Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowAddNewZonePopup" (click)="CloseAddNewZonePopup();">
  <div class="ModernPopup" style="width: 450px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">add</i>
        <span>{{ 'Configuration.AddNewZone' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="CloseAddNewZonePopup();">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <!-- Warehouse Selection -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'SelectWarehouse' | translate }}*</label>
        <div class="ZoneWarehouseSelector">
          <!-- Selected Warehouse Display -->
          <div class="SelectedWarehouseDisplay" *ngIf="SelectedZoneWarehouse">
            <i class="material-icons">warehouse</i>
            <span>{{SelectedZoneWarehouse.Name}}</span>
            <button class="ClearWarehouseButton" (click)="ClearZoneWarehouse();">
              <i class="material-icons">close</i>
            </button>
          </div>
          <!-- Warehouse Search Input -->
          <div class="WarehouseSearchWrapper" *ngIf="!SelectedZoneWarehouse">
            <div class="WarehouseSearchInputContainer">
              <i class="material-icons">search</i>
              <input type="text"
                     class="WarehouseSearchInput"
                     placeholder="{{ 'SelectWarehouse' | translate }}"
                     [(ngModel)]="ZoneWarehouseFilter.SearchTerm"
                     (ngModelChange)="zoneWarehouseSearchTermUpdate.next($event)"
                     (click)="InitializeZoneWarehouses();"
                     (focus)="zoneWarehouseSearchFocused = true">
              <i class="material-icons" *ngIf="ZoneWarehouseFilter?.SearchTerm?.length > 0" (click)="ZoneWarehouseFilter.SearchTerm = ''; ZoneWarehouses = [];" style="cursor: pointer; color: #5a7a9a;">close</i>
            </div>
            <!-- Search Results Dropdown -->
            <div class="WarehouseSearchResults" *ngIf="zoneWarehouseSearchFocused && ZoneWarehouses != null && ZoneWarehouses.length > 0">
              <div class="WarehouseSearchResultItem" *ngFor="let warehouse of ZoneWarehouses" (click)="SelectZoneWarehouse(warehouse);">
                <i class="material-icons">warehouse</i>
                <span>{{warehouse.Name}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Overlay to close search results -->
        <div class="ZoneWarehouseSearchOverlay" *ngIf="zoneWarehouseSearchFocused" (click)="zoneWarehouseSearchFocused = false;"></div>
      </div>
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'Name' | translate }}*</label>
        <input type="text" class="ModernFormInput" [(ngModel)]="NewWHZone.Name" placeholder="{{ 'Name' | translate }}">
      </div>
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'Description' | translate }}</label>
        <textarea class="ModernFormTextarea" [(ngModel)]="NewWHZone.Description" rows="3" placeholder="{{ 'Description' | translate }}"></textarea>
      </div>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" (click)="CloseAddNewZonePopup();">{{ 'Cancel' | translate }}</button>
      <button class="ModernButton success" [disabled]="this.StockLoading" (click)="AddNewWHZone();">
        <i class="material-icons spinner" *ngIf="this.StockLoading">refresh</i>
        <i class="material-icons" *ngIf="!this.StockLoading">save</i>
        <span>{{ 'Save' | translate }}</span>
      </button>
    </div>
  </div>
</div>
